export const he = {
  message: '🎉 עיצובים חדשים לקראת פסח, הירשם עכשיו לקבל 10% הנחה לקנייה ראשונה'
}; 